// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EmptyFilter__Wrapper_5587_"};